// Avatar Creator Configuration
// Loads all character layer images from local files using require.context
// Structure mirrors CharacterResources.js but uses bundled local assets

const girlsContext = require.context('../../images/avatar-creator/girls', true, /\.png$/);
const boysContext = require.context('../../images/avatar-creator/boys', true, /\.png$/);
const menContext = require.context('../../images/avatar-creator/men', true, /\.png$/);
const womenContext = require.context('../../images/avatar-creator/women', true, /\.png$/);

// Layer folder mappings
const LayerFolders = {
    Ears: "layer-01-ears",
    Body: "layer-02-body",
    Face: "layer-03-face",
    Mouth: "layer-04-mouth",
    Eyes: "layer-05-eyes",
    Brows: "layer-06-brows",
    Hair: "layer-07-hair",
    Nose: "layer-08-nose",
    Clothes: "layer-09-clothes",
    Extras: "layer-10-extras",
};

function getImage(context, layerFolder, fileName) {
    try {
        return context(`./${layerFolder}/${fileName}.png`);
    } catch (e) {
        console.warn(`Avatar image not found: ${layerFolder}/${fileName}.png`);
        return null;
    }
}

// Shortcut helpers for each character type
const G = (layer, file) => getImage(girlsContext, LayerFolders[layer], file);
const B = (layer, file) => getImage(boysContext, LayerFolders[layer], file);
const M = (layer, file) => getImage(menContext, LayerFolders[layer], file);
const W = (layer, file) => getImage(womenContext, LayerFolders[layer], file);

export const Characters = {
    Girl: {
        Ears: [
            [
                { Layer: G("Ears", "ears-L0-contour"), Color: null },
                { Layer: G("Ears", "ears-L1-skin-color-1"), Color: 1 },
                { Layer: G("Ears", "ears-L2-skin-color-2"), Color: 2 },
            ],
        ],
        Body: [
            [
                { Layer: G("Body", "body-L0-contour"), Color: null },
                { Layer: G("Body", "body-L1-skin-color-1"), Color: 1 },
                { Layer: G("Body", "body-L2-skin-color-2"), Color: 2 },
            ],
        ],
        Face: [
            {
                Layer0: G("Face", "face-L0-contour"),
                Layer1: G("Face", "face-L1-skin-color-1"),
                Layer2: [
                    G("Face", "face-L2-hair-3-skin-color-2"),
                    G("Face", "face-L2-hair-4-skin-color-2"),
                    G("Face", "face-L2-hair-5-skin-color-2"),
                    G("Face", "face-L2-hair-6-skin-color-2"),
                    G("Face", "face-L2-hair-10-skin-color-2"),
                    G("Face", "face-L2-hair-10-skin-color-2"),
                    G("Face", "face-L2-hair-4-skin-color-2"),
                    G("Face", "face-L2-hair-12-skin-color-2"),
                    G("Face", "face-L2-hair-13-skin-color-2"),
                    G("Face", "face-L2-hair-16-skin-color-2"),
                    G("Face", "face-L2-hair-20-skin-color-2"),
                    G("Face", "face-L2-hair-sport-skin-color-2"),
                ],
            },
        ],
        Mouth: [
            [{ Layer: G("Mouth", "mouth-9-L0"), Color: null }],
            [{ Layer: G("Mouth", "mouth-14-L0"), Color: null }],
            [
                { Layer: G("Mouth", "mouth-19-L0-skin-color-2"), Color: 2 },
                { Layer: G("Mouth", "mouth-19-L1"), Color: null },
            ],
            [{ Layer: G("Mouth", "mouth-23-L0"), Color: null }],
            [
                { Layer: G("Mouth", "mouth-24-L0-skin-color-2"), Color: 2 },
                { Layer: G("Mouth", "mouth-24-L1"), Color: null },
            ],
            [
                { Layer: G("Mouth", "mouth-26-L0-skin-color-2"), Color: 2 },
                { Layer: G("Mouth", "mouth-26-L1"), Color: null },
            ],
            [{ Layer: G("Mouth", "mouth-28-L0"), Color: null }],
            [{ Layer: G("Mouth", "mouth-36-L0"), Color: null }],
            [{ Layer: G("Mouth", "mouth-37-L0"), Color: null }],
        ],
        Eyes: [
            [{ Layer: G("Eyes", "eyes-2-L0"), Color: null }],
            [{ Layer: G("Eyes", "eyes-4-L0"), Color: null }],
            [{ Layer: G("Eyes", "eyes-8-L0"), Color: null }],
            [{ Layer: G("Eyes", "eyes-12-L0"), Color: null }],
            [{ Layer: G("Eyes", "eyes-18-L0"), Color: null }],
            [{ Layer: G("Eyes", "eyes-19-L0"), Color: null }],
            [{ Layer: G("Eyes", "eyes-21-L0"), Color: null }],
            [{ Layer: G("Eyes", "eyes-23-L0"), Color: null }],
            [{ Layer: G("Eyes", "eyes-24-L0"), Color: null }],
            [{ Layer: G("Eyes", "eyes-25-L0"), Color: null }],
        ],
        Brows: [
            [{ Layer: G("Brows", "brows-1-L0"), Color: null }],
            [{ Layer: G("Brows", "brows-4-L0"), Color: null }],
            [{ Layer: G("Brows", "brows-21-L0"), Color: null }],
            [{ Layer: G("Brows", "brows-22-L0"), Color: null }],
            [{ Layer: G("Brows", "brows-23-L0"), Color: null }],
            [{ Layer: G("Brows", "brows-24-L0"), Color: null }],
            [{ Layer: G("Brows", "brows-25-L0"), Color: null }],
            [{ Layer: G("Brows", "brows-26-L0"), Color: null }],
            [{ Layer: G("Brows", "brows-27-L0"), Color: null }],
            [{ Layer: G("Brows", "brows-28-L0"), Color: null }],
        ],
        Hair: [
            [
                { Layer: G("Hair", "hair-3-L0-contour"), Color: null },
                { Layer: G("Hair", "hair-3-L1-hair-color-2"), Color: 3 },
                { Layer: G("Hair", "hair-3-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: G("Hair", "hair-4-L0-contour"), Color: null },
                { Layer: G("Hair", "hair-4-L1-hair-color-2"), Color: 3 },
                { Layer: G("Hair", "hair-4-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: G("Hair", "hair-5-L0-contour"), Color: null },
                { Layer: G("Hair", "hair-5-L1-hair-color-2"), Color: 3 },
                { Layer: G("Hair", "hair-5-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: G("Hair", "hair-6-L0-contour"), Color: null },
                { Layer: G("Hair", "hair-6-L1-hair-color-2"), Color: 3 },
                { Layer: G("Hair", "hair-6-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: G("Hair", "hair-9-L0-contour"), Color: null },
                { Layer: G("Hair", "hair-9-L1-hair-color-2"), Color: 3 },
                { Layer: G("Hair", "hair-9-L2-hair-color-1"), Color: 4 },
                { Layer: G("Hair", "hair-9-L3-outfit-color-1"), Color: 5 },
                { Layer: G("Hair", "hair-9-L4-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: G("Hair", "hair-10-L0-contour"), Color: null },
                { Layer: G("Hair", "hair-10-L1-hair-color-2"), Color: 3 },
                { Layer: G("Hair", "hair-10-L2-hair-color-1"), Color: 4 },
            ],
            [{ Layer: G("Hair", "hair-bold"), Color: null }],
            [
                { Layer: G("Hair", "hair-12-L0-contour"), Color: null },
                { Layer: G("Hair", "hair-12-L1-hair-color-2"), Color: 3 },
                { Layer: G("Hair", "hair-12-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: G("Hair", "hair-13-L0-contour"), Color: null },
                { Layer: G("Hair", "hair-13-L1-hair-color-2"), Color: 3 },
                { Layer: G("Hair", "hair-13-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: G("Hair", "hair-16-L0-contour"), Color: null },
                { Layer: G("Hair", "hair-16-L1-hair-color-2"), Color: 3 },
                { Layer: G("Hair", "hair-16-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: G("Hair", "hair-20-L0-contour"), Color: null },
                { Layer: G("Hair", "hair-20-L1-hair-color-2"), Color: 3 },
                { Layer: G("Hair", "hair-20-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: G("Hair", "hair-sport-L0-contour"), Color: null },
                { Layer: G("Hair", "hair-sport-L1-hair-color-2"), Color: 3 },
                { Layer: G("Hair", "hair-sport-L2-hair-color-1"), Color: 4 },
                { Layer: G("Hair", "hair-sport-L3-outfit-color-1"), Color: 5 },
                { Layer: G("Hair", "hair-sport-L4-outfit-color-2"), Color: 6 },
                { Layer: G("Hair", "hair-sport-L5-white"), Color: 5 },
            ],
        ],
        Nose: [
            [
                { Layer: G("Nose", "nose-1-L0-skin-color-2"), Color: 2 },
                { Layer: G("Nose", "nose-1-L1-contour"), Color: null },
            ],
            [
                { Layer: G("Nose", "nose-2-L0-skin-color-2"), Color: 2 },
                { Layer: G("Nose", "nose-2-L1-contour"), Color: null },
            ],
            [
                { Layer: G("Nose", "nose-3-L0-skin-color-2"), Color: 2 },
                { Layer: G("Nose", "nose-3-L1-contour"), Color: null },
            ],
            [
                { Layer: G("Nose", "nose-6-L0-skin-color-2"), Color: 2 },
                { Layer: G("Nose", "nose-6-L1-contour"), Color: null },
            ],
            [
                { Layer: G("Nose", "nose-8-L0-skin-color-2"), Color: 2 },
                { Layer: G("Nose", "nose-8-L1-contour"), Color: null },
            ],
            [
                { Layer: G("Nose", "nose-10-L0-skin-color-2"), Color: 2 },
                { Layer: G("Nose", "nose-10-L1-contour"), Color: null },
            ],
            [
                { Layer: G("Nose", "nose-11-L0-skin-color-2"), Color: 2 },
                { Layer: G("Nose", "nose-11-L1-contour"), Color: null },
            ],
            [
                { Layer: G("Nose", "nose-14-L0-skin-color-2"), Color: 2 },
                { Layer: G("Nose", "nose-14-L1-contour"), Color: null },
            ],
            [
                { Layer: G("Nose", "nose-22-L0-skin-color-2"), Color: 2 },
                { Layer: G("Nose", "nose-22-L1-contour"), Color: null },
            ],
            [
                { Layer: G("Nose", "nose-easter-L0-skin-color-2"), Color: 2 },
                { Layer: G("Nose", "nose-easter-L1-contour"), Color: null },
                { Layer: G("Nose", "face-L3-easter-skin-color-3"), Color: 9 },
            ],
        ],
        Clothes: [
            [
                { Layer: G("Clothes", "clothes-1-L0-contour"), Color: null },
                { Layer: G("Clothes", "clothes-1-L1-outfit-color-1"), Color: 5 },
                { Layer: G("Clothes", "clothes-1-L2-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: G("Clothes", "clothes-2-L0-contour"), Color: null },
                { Layer: G("Clothes", "clothes-2-L1-outfit-color-1"), Color: 5 },
                { Layer: G("Clothes", "clothes-2-L2-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: G("Clothes", "clothes-3-L0-contour"), Color: null },
                { Layer: G("Clothes", "clothes-3-L1-outfit-color-1"), Color: 5 },
                { Layer: G("Clothes", "clothes-3-L2-outfit-color-2"), Color: 6 },
                { Layer: G("Clothes", "clothes-3-L3-outfit-color-3"), Color: 7 },
                { Layer: G("Clothes", "clothes-3-L4-outfit-color-4"), Color: 8 },
            ],
            [
                { Layer: G("Clothes", "clothes-4-L0-contour"), Color: null },
                { Layer: G("Clothes", "clothes-4-L1-outfit-color-1"), Color: 5 },
                { Layer: G("Clothes", "clothes-4-L2-outfit-color-3"), Color: 7 },
                { Layer: G("Clothes", "clothes-4-L3-outfit-color-4"), Color: 8 },
            ],
            [
                { Layer: G("Clothes", "clothes-5-L0-contour"), Color: null },
                { Layer: G("Clothes", "clothes-5-L1-outfit-color-1"), Color: 5 },
                { Layer: G("Clothes", "clothes-5-L2-outfit-color-2"), Color: 6 },
                { Layer: G("Clothes", "clothes-5-L3-outfit-color-3"), Color: 7 },
                { Layer: G("Clothes", "clothes-5-L4-outfit-color-4"), Color: 8 },
            ],
            [
                { Layer: G("Clothes", "clothes-6-L0-contour"), Color: null },
                { Layer: G("Clothes", "clothes-6-L1-outfit-color-1"), Color: 5 },
                { Layer: G("Clothes", "clothes-6-L2-outfit-color-2"), Color: 6 },
                { Layer: G("Clothes", "clothes-6-L3-outfit-color-3"), Color: 7 },
                { Layer: G("Clothes", "clothes-6-L4-outfit-color-4"), Color: 8 },
            ],
            [
                { Layer: G("Clothes", "clothes-7-L0-contour"), Color: null },
                { Layer: G("Clothes", "clothes-7-L1-outfit-color-1"), Color: 5 },
                { Layer: G("Clothes", "clothes-7-L2-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: G("Clothes", "clothes-8-L0-contour"), Color: null },
                { Layer: G("Clothes", "clothes-8-L1-outfit-color-1"), Color: 5 },
                { Layer: G("Clothes", "clothes-8-L2-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: G("Clothes", "clothes-sport-L0-contour"), Color: null },
                { Layer: G("Clothes", "clothes-sport-L1-outfit-color-1"), Color: 5 },
                { Layer: G("Clothes", "clothes-sport-L2-outfit-color-2"), Color: 6 },
                { Layer: G("Clothes", "clothes-sport-L3-white"), Color: 7 },
                { Layer: G("Clothes", "clothes-sport-L4-shadow"), Color: 8 },
            ],
            [
                { Layer: G("Clothes", "clothes-easter-L0-contour"), Color: null },
                { Layer: G("Clothes", "clothes-easter-L1-outfit-color-1"), Color: 5 },
                { Layer: G("Clothes", "clothes-easter-L2-outfit-color-2"), Color: 6 },
                { Layer: G("Clothes", "clothes-easter-L3-eggs"), Color: 7 },
            ],
            [
                { Layer: G("Clothes", "clothes-superhero-L0-outfit-color-1"), Color: 5 },
                { Layer: G("Clothes", "clothes-superhero-L1-outfit-color-2"), Color: 6 },
                { Layer: G("Clothes", "clothes-superhero-L2-contour"), Color: null },
                { Layer: G("Clothes", "clothes-superhero-L3-outfit-color-3"), Color: 7 },
                { Layer: G("Clothes", "clothes-superhero-L4-outfit-color-4"), Color: 8 },
                { Layer: G("Clothes", "clothes-superhero-L5-cape"), Color: null },
            ],
            [
                { Layer: G("Clothes", "space-suit-L0-contour"), Color: null },
                { Layer: G("Clothes", "space-suit-L1-outfit-color-3"), Color: 7 },
                { Layer: G("Clothes", "space-suit-L2-outfit-color-4"), Color: 8 },
                { Layer: G("Clothes", "space-suit-L3-outfit-color-1"), Color: 5 },
                { Layer: G("Clothes", "space-suit-L4-outfit-color-2"), Color: 6 },
                { Layer: G("Clothes", "space-suit-L5-white"), Color: null },
            ],
        ],
        Extras: [
            [{ Layer: G("Extras", "extras-9-glasses-2-L0"), Color: null }],
            [{ Layer: G("Extras", "extras-4-screws-L0"), Color: null }],
            [{ Layer: G("Extras", "extras-5-wound-L0-skin-color-2"), Color: 2 }],
            [{ Layer: G("Extras", "extras-6-earrings-L0"), Color: null }],
            [{ Layer: G("Extras", "extras-7-earrings-2-L0"), Color: null }],
            [{ Layer: G("Extras", "extras-8-earrings-3-L0"), Color: null }],
            [{ Layer: G("Extras", "extras-10-glasses-L0"), Color: null }],
            [
                { Layer: G("Extras", "extras-11-bow-L0-contour"), Color: null },
                { Layer: G("Extras", "extras-11-bow-L1-outfit-color-1"), Color: 5 },
                { Layer: G("Extras", "extras-11-bow-L2-outfit-color-2"), Color: 6 },
                { Layer: G("Extras", "extras-11-bow-L3-outfit-color-3"), Color: 7 },
            ],
            [{ Layer: G("Extras", "extras-12-crown-L0"), Color: null }],
            [{ Layer: G("Extras", "extras-13-rabbit-L0"), Color: null }],
            [
                { Layer: G("Extras", "extras-easter-L0-contour"), Color: null },
                { Layer: G("Extras", "extras-easter-L1-outfit-color-1"), Color: 5 },
                { Layer: G("Extras", "extras-easter-L2-outfit-color-2"), Color: 6 },
                { Layer: G("Extras", "extras-easter-L2-skin-color-1"), Color: 1 },
                { Layer: G("Extras", "extras-easter-L3-skin-color-2"), Color: 2 },
            ],
            [{ Layer: G("Extras", "face-L3-superhero-mask"), Color: null }],
            [
                { Layer: G("Extras", "space-helmet-L0-contour"), Color: null },
                { Layer: G("Extras", "space-helmet-L1-outfit-color-3"), Color: 7 },
                { Layer: G("Extras", "space-helmet-L2-outfit-color-4"), Color: 8 },
                { Layer: G("Extras", "space-helmet-L3-outfit-color-1"), Color: 5 },
                { Layer: G("Extras", "space-helmet-L4-outfit-color-2"), Color: 6 },
                { Layer: G("Extras", "space-helmet-L5-white"), Color: null },
            ],
        ],
    },
    Boy: {
        Ears: [
            [
                { Layer: B("Ears", "ears-L0-contour"), Color: null },
                { Layer: B("Ears", "ears-L1-skin-color-1"), Color: 1 },
            ],
        ],
        Body: [
            [
                { Layer: B("Clothes", "body-8-L0-contour"), Color: null },
                { Layer: B("Clothes", "body-8-L1-outfit-color-1"), Color: 1 },
                { Layer: B("Clothes", "body-8-L2-outfit-color-2"), Color: 1 },
                { Layer: B("Clothes", "body-8-L3-outfit-color-3"), Color: 1 },
                { Layer: B("Clothes", "body-8-L4-skin-color-2"), Color: 2 },
            ],
        ],
        Face: [
            {
                Layer0: B("Face", "face-L0-contour"),
                Layer1: B("Face", "face-L1-skin-color-1"),
                Layer2: [
                    B("Face", "face-L2-hair-5-skin-color-2"),
                    B("Face", "face-L2-hair-6-skin-color-2"),
                    B("Face", "face-L2-hair-7-skin-color-2"),
                    B("Face", "face-L2-hair-10-skin-color-2"),
                    B("Face", "face-L2-hair-14-skin-color-2"),
                    B("Face", "face-L2-hair-16-skin-color-2"),
                    B("Face", "face-L2-hair-7-skin-color-2"),
                    B("Face", "face-L2-hair-17-skin-color-2"),
                    B("Face", "face-L2-hair-20-skin-color-2"),
                    B("Face", "face-L2-hair-21-skin-color-2"),
                    B("Face", "face-L2-hair-22-skin-color-2"),
                    B("Face", "face-L2-hair-sport-skin-color-2"),
                    B("Face", "face-L2-hair-superhero-skin-color-2"),
                ],
            },
        ],
        Mouth: [
            [{ Layer: B("Mouth", "mouth-1-L0"), Color: null }],
            [
                { Layer: B("Mouth", "mouth-2-L0-skin-color-2"), Color: 2 },
                { Layer: B("Mouth", "mouth-2-L1"), Color: null },
            ],
            [
                { Layer: B("Mouth", "mouth-3-L0-skin-color-2"), Color: 2 },
                { Layer: B("Mouth", "mouth-3-L1"), Color: null },
            ],
            [
                { Layer: B("Mouth", "mouth-4-L0-skin-color-2"), Color: 2 },
                { Layer: B("Mouth", "mouth-4-L1"), Color: null },
            ],
            [
                { Layer: B("Mouth", "mouth-10-L0-skin-color-2"), Color: 2 },
                { Layer: B("Mouth", "mouth-10-L1"), Color: null },
            ],
            [{ Layer: B("Mouth", "mouth-12-L0"), Color: null }],
            [
                { Layer: B("Mouth", "mouth-19-L0-skin-color-2"), Color: 2 },
                { Layer: B("Mouth", "mouth-19-L1"), Color: null },
            ],
            [{ Layer: B("Mouth", "mouth-28-L0"), Color: null }],
            [{ Layer: B("Mouth", "mouth-29-L0"), Color: null }],
        ],
        Eyes: [
            [{ Layer: B("Eyes", "eyes-1-L0"), Color: null }],
            [{ Layer: B("Eyes", "eyes-4-L0"), Color: null }],
            [{ Layer: B("Eyes", "eyes-5-L0"), Color: null }],
            [{ Layer: B("Eyes", "eyes-8-L0"), Color: null }],
            [{ Layer: B("Eyes", "eyes-11-L0"), Color: null }],
            [{ Layer: B("Eyes", "eyes-12-L0"), Color: null }],
            [{ Layer: B("Eyes", "eyes-14-L0"), Color: null }],
            [{ Layer: B("Eyes", "eyes-18-L0"), Color: null }],
            [{ Layer: B("Eyes", "eyes-19-L0"), Color: null }],
            [{ Layer: B("Eyes", "eyes-21-L0"), Color: null }],
        ],
        Brows: [
            [{ Layer: B("Brows", "brows-1-L0"), Color: null }],
            [{ Layer: B("Brows", "brows-3-L0"), Color: null }],
            [{ Layer: B("Brows", "brows-4-L0"), Color: null }],
            [{ Layer: B("Brows", "brows-7-L0"), Color: null }],
            [{ Layer: B("Brows", "brows-10-L0"), Color: null }],
            [{ Layer: B("Brows", "brows-12-L0"), Color: null }],
            [{ Layer: B("Brows", "brows-15-L0"), Color: null }],
            [{ Layer: B("Brows", "brows-16-L0"), Color: null }],
            [{ Layer: B("Brows", "brows-18-L0"), Color: null }],
            [{ Layer: B("Brows", "brows-22-L0"), Color: null }],
        ],
        Hair: [
            [
                { Layer: B("Hair", "hair-5-L0-contour"), Color: null },
                { Layer: B("Hair", "hair-5-L1-hair-color-2"), Color: 3 },
                { Layer: B("Hair", "hair-5-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: B("Hair", "hair-6-L0-contour"), Color: null },
                { Layer: B("Hair", "hair-6-L1-hair-color-2"), Color: 3 },
                { Layer: B("Hair", "hair-6-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: B("Hair", "hair-7-L0-contour"), Color: null },
                { Layer: B("Hair", "hair-7-L1-hair-color-2"), Color: 3 },
                { Layer: B("Hair", "hair-7-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: B("Hair", "hair-10-L0-contour"), Color: null },
                { Layer: B("Hair", "hair-10-L1-hair-color-2"), Color: 3 },
                { Layer: B("Hair", "hair-10-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: B("Hair", "hair-14-L0-contour"), Color: null },
                { Layer: B("Hair", "hair-14-L1-hair-color-2"), Color: 3 },
                { Layer: B("Hair", "hair-14-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: B("Hair", "hair-16-L0-contour"), Color: null },
                { Layer: B("Hair", "hair-16-L1-hair-color-2"), Color: 3 },
                { Layer: B("Hair", "hair-16-L2-hair-color-1"), Color: 4 },
            ],
            [{ Layer: B("Hair", "hair-bold"), Color: null }],
            [
                { Layer: B("Hair", "hair-17-L0-contour"), Color: null },
                { Layer: B("Hair", "hair-17-L1-hair-color-2"), Color: 3 },
                { Layer: B("Hair", "hair-17-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: B("Hair", "hair-20-L0-contour"), Color: null },
                { Layer: B("Hair", "hair-20-L1-hair-color-2"), Color: 3 },
                { Layer: B("Hair", "hair-20-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: B("Hair", "hair-21-L0-contour"), Color: null },
                { Layer: B("Hair", "hair-21-L1-hair-color-2"), Color: 3 },
                { Layer: B("Hair", "hair-21-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: B("Hair", "hair-22-L0-contour"), Color: null },
                { Layer: B("Hair", "hair-22-L1-hair-color-2"), Color: 3 },
                { Layer: B("Hair", "hair-22-L3-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: B("Extras", "extras-2-hat-L0-contour"), Color: null },
                { Layer: B("Extras", "extras-2-hat-L1-outfit-color-3"), Color: 7 },
                { Layer: B("Extras", "extras-2-hat-L2-outfit-color-3"), Color: 7 },
                { Layer: B("Extras", "extras-2-hat-L3-outfit-color-1"), Color: 5 },
                { Layer: B("Extras", "extras-2-hat-L4-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: B("Hair", "hair-sport-L0-contour"), Color: null },
                { Layer: B("Hair", "hair-sport-L1-hair-color-2"), Color: 3 },
                { Layer: B("Hair", "hair-sport-L2-hair-color-1"), Color: 4 },
                { Layer: B("Hair", "hair-sport-L3-contour"), Color: null },
                { Layer: B("Hair", "hair-sport-L4-outfit-color-1"), Color: 5 },
                { Layer: B("Hair", "hair-sport-L5-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: B("Hair", "hair-superhero-L0-contour"), Color: null },
                { Layer: B("Hair", "hair-superhero-L1-hair-color-2"), Color: 3 },
                { Layer: B("Hair", "hair-superhero-L2-hair-color-1"), Color: 4 },
            ],
        ],
        Nose: [
            [
                { Layer: B("Nose", "nose-1-L0-skin-color-2"), Color: 2 },
                { Layer: B("Nose", "nose-1-L1-contour"), Color: null },
            ],
            [
                { Layer: B("Nose", "nose-2-L0-skin-color-2"), Color: 2 },
                { Layer: B("Nose", "nose-2-L1-contour"), Color: null },
            ],
            [
                { Layer: B("Nose", "nose-4-L0-skin-color-2"), Color: 2 },
                { Layer: B("Nose", "nose-4-L1-contour"), Color: null },
            ],
            [
                { Layer: B("Nose", "nose-5-L0-skin-color-2"), Color: 2 },
                { Layer: B("Nose", "nose-5-L1-contour"), Color: null },
            ],
            [
                { Layer: B("Nose", "nose-6-L0-skin-color-2"), Color: 2 },
                { Layer: B("Nose", "nose-6-L1-contour"), Color: null },
            ],
            [
                { Layer: B("Nose", "nose-7-L0-skin-color-2"), Color: 2 },
                { Layer: B("Nose", "nose-7-L1-contour"), Color: null },
            ],
            [
                { Layer: B("Nose", "nose-12-L0-skin-color-2"), Color: 2 },
                { Layer: B("Nose", "nose-12-L1-contour"), Color: null },
            ],
            [
                { Layer: B("Nose", "nose-13-L0-skin-color-2"), Color: 2 },
                { Layer: B("Nose", "nose-13-L1-contour"), Color: null },
            ],
            [
                { Layer: B("Nose", "nose-14-L0-skin-color-2"), Color: 2 },
                { Layer: B("Nose", "nose-14-L1-contour"), Color: null },
            ],
            [
                { Layer: B("Nose", "nose-18-L0-skin-color-2"), Color: 2 },
                { Layer: B("Nose", "nose-18-L1-contour"), Color: null },
            ],
            [
                { Layer: B("Nose", "nose-easter-L0-skin-color-2"), Color: 2 },
                { Layer: B("Nose", "nose-easter-L1-contour"), Color: null },
                { Layer: B("Nose", "face-L3-easter-skin-color-3"), Color: 9 },
            ],
        ],
        Clothes: [
            [
                { Layer: B("Clothes", "body-1-L0-contour"), Color: null },
                { Layer: B("Clothes", "body-1-L1-outfit-color-1"), Color: 5 },
                { Layer: B("Clothes", "body-1-L2-outfit-color-2"), Color: 6 },
                { Layer: B("Clothes", "body-1-L3-outfit-color-3"), Color: 7 },
                { Layer: B("Clothes", "body-1-L4-skin-color-2"), Color: 2 },
            ],
            [
                { Layer: B("Clothes", "body-2-L0-contour"), Color: null },
                { Layer: B("Clothes", "body-2-L1-outfit-color-1"), Color: 5 },
                { Layer: B("Clothes", "body-2-L2-outfit-color-2"), Color: 6 },
                { Layer: B("Clothes", "body-2-L3-outfit-color-3"), Color: 7 },
                { Layer: B("Clothes", "body-2-L4-outfit-color-4"), Color: 8 },
                { Layer: B("Clothes", "body-2-L5-skin-color-2"), Color: 2 },
            ],
            [
                { Layer: B("Clothes", "body-3-L0-contour"), Color: null },
                { Layer: B("Clothes", "body-3-L1-outfit-color-1"), Color: 5 },
                { Layer: B("Clothes", "body-3-L2-outfit-color-2"), Color: 6 },
                { Layer: B("Clothes", "body-3-L3-skin-color-2"), Color: 2 },
            ],
            [
                { Layer: B("Clothes", "body-4-L0-contour"), Color: null },
                { Layer: B("Clothes", "body-4-L1-outfit-color-1"), Color: 5 },
                { Layer: B("Clothes", "body-4-L3-outfit-color-3"), Color: 7 },
                { Layer: B("Clothes", "body-5-L4-skin-color-2"), Color: 2 },
            ],
            [
                { Layer: B("Clothes", "body-5-L0-contour"), Color: null },
                { Layer: B("Clothes", "body-5-L1-outfit-color-1"), Color: 5 },
                { Layer: B("Clothes", "body-5-L2-outfit-color-2"), Color: 6 },
                { Layer: B("Clothes", "body-5-L3-outfit-color-3"), Color: 7 },
                { Layer: B("Clothes", "body-5-L4-skin-color-2"), Color: 2 },
            ],
            [
                { Layer: B("Clothes", "body-6-L0-contour"), Color: null },
                { Layer: B("Clothes", "body-6-L1-outfit-color-1"), Color: 5 },
                { Layer: B("Clothes", "body-6-L2-outfit-color-2"), Color: 6 },
                { Layer: B("Clothes", "body-6-L3-outfit-color-3"), Color: 7 },
                { Layer: B("Clothes", "body-6-L4-skin-color-2"), Color: 2 },
            ],
            [
                { Layer: B("Clothes", "body-7-L0-contour"), Color: null },
                { Layer: B("Clothes", "body-7-L1-outfit-color-1"), Color: 5 },
                { Layer: B("Clothes", "body-7-L2-outfit-color-2"), Color: 6 },
                { Layer: B("Clothes", "body-7-L3-skin-color-2"), Color: 2 },
            ],
            [
                { Layer: B("Clothes", "body-8-L0-contour"), Color: null },
                { Layer: B("Clothes", "body-8-L1-outfit-color-1"), Color: 5 },
                { Layer: B("Clothes", "body-8-L2-outfit-color-2"), Color: 6 },
                { Layer: B("Clothes", "body-8-L3-outfit-color-3"), Color: 7 },
                { Layer: B("Clothes", "body-8-L4-skin-color-2"), Color: 2 },
            ],
            [
                { Layer: B("Clothes", "body-sport-L0-contour"), Color: null },
                { Layer: B("Clothes", "body-sport-L1-skin-color-1"), Color: 1 },
                { Layer: B("Clothes", "body-sport-L2-skin-color-2"), Color: 2 },
                { Layer: B("Clothes", "body-sport-L3-contour"), Color: null },
                { Layer: B("Clothes", "body-sport-L4-outfit-color-1"), Color: 5 },
                { Layer: B("Clothes", "body-sport-L5-outfit-color-2"), Color: 6 },
                { Layer: B("Clothes", "body-sport-L6-white"), Color: 7 },
                { Layer: B("Clothes", "body-sport-L7-shadow"), Color: 8 },
            ],
            [
                { Layer: B("Clothes", "body-easter-L0-contour"), Color: null },
                { Layer: B("Clothes", "body-easter-L1-skin-color-2"), Color: 2 },
                { Layer: B("Clothes", "body-easter-L2-hair-color-1"), Color: 5 },
                { Layer: B("Clothes", "body-easter-L3-hair-color-2"), Color: 6 },
            ],
            [
                { Layer: B("Clothes", "body-superhero-L0-contour1"), Color: null },
                { Layer: B("Clothes", "body-superhero-L1-skin-color-2new"), Color: 2 },
                { Layer: B("Clothes", "body-superhero-L2-outfit-color-1"), Color: 5 },
                { Layer: B("Clothes", "body-superhero-L3-outfit-color-2"), Color: 6 },
                { Layer: B("Clothes", "body-superhero-L4-outfit-color-3"), Color: 7 },
                { Layer: B("Clothes", "body-superhero-L5-outfit-color-4"), Color: 8 },
                { Layer: B("Clothes", "body-superhero-L6-cape"), Color: null },
            ],
            [
                { Layer: B("Clothes", "body-1-L0-contour"), Color: null },
                { Layer: B("Clothes", "body-1-L4-skin-color-2"), Color: 2 },
                { Layer: B("Clothes", "space-suit-L0-contour"), Color: null },
                { Layer: B("Clothes", "space-suit-L1-outfit-color-3"), Color: 7 },
                { Layer: B("Clothes", "space-suit-L2-outfit-color-4"), Color: 8 },
                { Layer: B("Clothes", "space-suit-L3-outfit-color-1"), Color: 5 },
                { Layer: B("Clothes", "space-suit-L4-outfit-color-2"), Color: 6 },
                { Layer: B("Clothes", "space-suit-L5-white"), Color: null },
            ],
        ],
        Extras: [
            [{ Layer: B("Extras", "extras-3-freckless-L0-skin-color-2"), Color: 2 }],
            [{ Layer: B("Extras", "extras-1-moustache-L0"), Color: null }],
            [{ Layer: B("Extras", "extras-5-screws-L0"), Color: null }],
            [{ Layer: B("Extras", "extras-6-wound-L0-skin-color-2"), Color: 2 }],
            [{ Layer: B("Extras", "extras-7-beard-1-L0"), Color: null }],
            [{ Layer: B("Extras", "extras-8-beard-2-L0"), Color: null }],
            [{ Layer: B("Extras", "extras-9-earrings-L0"), Color: null }],
            [{ Layer: B("Extras", "extras-10-glasses-L0"), Color: null }],
            [
                { Layer: B("Extras", "extras-easter-L0-contour"), Color: null },
                { Layer: B("Extras", "extras-easter-L1-outfit-color-1"), Color: 5 },
                { Layer: B("Extras", "extras-easter-L2-outfit-color-2"), Color: 6 },
                { Layer: B("Extras", "extras-easter-L2-skin-color-1"), Color: 1 },
                { Layer: B("Extras", "extras-easter-L3-skin-color-2"), Color: 2 },
            ],
            [{ Layer: B("Extras", "face-L3-superhero-mask"), Color: null }],
            [
                { Layer: B("Extras", "space-helmet-L0-contour"), Color: null },
                { Layer: B("Extras", "space-helmet-L1-outfit-color-3"), Color: 7 },
                { Layer: B("Extras", "space-helmet-L2-outfit-color-4"), Color: 8 },
                { Layer: B("Extras", "space-helmet-L3-outfit-color-1"), Color: 5 },
                { Layer: B("Extras", "space-helmet-L4-outfit-color-2"), Color: 6 },
                { Layer: B("Extras", "space-helmet-L5-white"), Color: null },
            ],
        ],
    },
    Man: {
        Ears: [
            [
                { Layer: M("Ears", "ears-L0-contour"), Color: null },
                { Layer: M("Ears", "ears-L1-skin-color-1"), Color: 1 },
                { Layer: M("Ears", "ears-L2-skin-color-2"), Color: 2 },
            ],
        ],
        Body: [
            [
                { Layer: M("Clothes", "body-1-L0-contour"), Color: null },
                { Layer: M("Clothes", "body-1-L1-skin-color-2"), Color: 1 },
                { Layer: M("Clothes", "body-1-L2-outfit-color-1"), Color: 1 },
                { Layer: M("Clothes", "body-1-L3-outfit-color-2"), Color: 2 },
            ],
        ],
        Face: [
            {
                Layer0: M("Face", "face-L0-contour"),
                Layer1: M("Face", "face-L1-skin-color-1"),
                Layer2: [
                    M("Face", "face-L2-hair-1-skin-color-2"),
                    M("Face", "face-L2-hair-2-skin-color-2"),
                    M("Face", "face-L2-hair-3-skin-color-2"),
                    M("Face", "face-L2-hair-4-skin-color-2"),
                    M("Face", "face-L2-hair-5-skin-color-2"),
                    M("Face", "face-L2-hair-6-skin-color-2"),
                    M("Face", "face-L2-hair-11-bold-skin-color-2"),
                    M("Face", "face-L2-hair-7-skin-color-2"),
                    M("Face", "face-L2-hair-8-skin-color-2"),
                    M("Face", "face-L2-hair-9-skin-color-2"),
                    M("Face", "face-L2-hair-10-skin-color-2"),
                    M("Face", "face-L2-hair-sport-skin-color-2"),
                    M("Face", "face-L2-hair-superhero-skin-color-2"),
                ],
            },
        ],
        Mouth: [
            [
                { Layer: M("Mouth", "mouth-26-L0-skin-color-2"), Color: 2 },
                { Layer: M("Mouth", "mouth-26-L1"), Color: null },
            ],
            [
                { Layer: M("Mouth", "mouth-2-L0-skin-color-2"), Color: 2 },
                { Layer: M("Mouth", "mouth-2-L1"), Color: null },
            ],
            [
                { Layer: M("Mouth", "mouth-4-L0-skin-color-2"), Color: 2 },
                { Layer: M("Mouth", "mouth-4-L1"), Color: null },
            ],
            [
                { Layer: M("Mouth", "mouth-8-L0"), Color: null },
                { Layer: M("Mouth", "mouth-8-L1"), Color: null },
            ],
            [{ Layer: M("Mouth", "mouth-9-L0"), Color: null }],
            [{ Layer: M("Mouth", "mouth-12-L0"), Color: null }],
            [{ Layer: M("Mouth", "mouth-14-L0"), Color: null }],
            [{ Layer: M("Mouth", "mouth-18-L0"), Color: null }],
            [
                { Layer: M("Mouth", "mouth-19-L0-skin-color-2"), Color: 2 },
                { Layer: M("Mouth", "mouth-19-L1"), Color: null },
            ],
            [{ Layer: M("Mouth", "mouth-23-L0"), Color: null }],
        ],
        Eyes: [
            [{ Layer: M("Eyes", "eyes-7-L0"), Color: null }],
            [{ Layer: M("Eyes", "eyes-1-L0"), Color: null }],
            [{ Layer: M("Eyes", "eyes-8-L0"), Color: null }],
            [{ Layer: M("Eyes", "eyes-11-L0"), Color: null }],
            [{ Layer: M("Eyes", "eyes-12-L0"), Color: null }],
            [{ Layer: M("Eyes", "eyes-14-L0"), Color: null }],
            [{ Layer: M("Eyes", "eyes-15-L0"), Color: null }],
            [{ Layer: M("Eyes", "eyes-16-L0"), Color: null }],
            [{ Layer: M("Eyes", "eyes-17-L0"), Color: null }],
            [{ Layer: M("Eyes", "eyes-18-L0"), Color: null }],
            [{ Layer: M("Eyes", "eyes-20-L0"), Color: null }],
        ],
        Brows: [
            [{ Layer: M("Brows", "brows-1-L0"), Color: null }],
            [{ Layer: M("Brows", "brows-3-L0"), Color: null }],
            [{ Layer: M("Brows", "brows-7-L0"), Color: null }],
            [{ Layer: M("Brows", "brows-14-L0"), Color: null }],
            [{ Layer: M("Brows", "brows-15-L0"), Color: null }],
            [{ Layer: M("Brows", "brows-18-L0"), Color: null }],
            [{ Layer: M("Brows", "brows-19-L0"), Color: null }],
            [{ Layer: M("Brows", "brows-22-L0"), Color: null }],
            [{ Layer: M("Brows", "brows-24-L0"), Color: null }],
            [{ Layer: M("Brows", "brows-27-L0"), Color: null }],
        ],
        Hair: [
            [
                { Layer: M("Hair", "hair-1-L0-contour"), Color: null },
                { Layer: M("Hair", "hair-1-L1-hair-color-2"), Color: 3 },
                { Layer: M("Hair", "hair-1-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: M("Hair", "hair-2-L0-contour"), Color: null },
                { Layer: M("Hair", "hair-2-L1-hair-color-2"), Color: 3 },
                { Layer: M("Hair", "hair-2-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: M("Hair", "hair-3-L0-contour"), Color: null },
                { Layer: M("Hair", "hair-3-L1-hair-color-2"), Color: 3 },
                { Layer: M("Hair", "hair-3-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: M("Hair", "hair-4-L0-contour"), Color: null },
                { Layer: M("Hair", "hair-4-L1-hair-color-2"), Color: 3 },
                { Layer: M("Hair", "hair-4-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: M("Hair", "hair-5-L0-contour"), Color: null },
                { Layer: M("Hair", "hair-5-L1-hair-color-2"), Color: 3 },
                { Layer: M("Hair", "hair-5-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: M("Hair", "hair-6-L0-contour"), Color: null },
                { Layer: M("Hair", "hair-6-L1-hair-color-2"), Color: 3 },
                { Layer: M("Hair", "hair-6-L2-hair-color-1"), Color: 4 },
            ],
            [{ Layer: M("Hair", "hair-bold"), Color: null }],
            [
                { Layer: M("Hair", "hair-7-L0-contour"), Color: null },
                { Layer: M("Hair", "hair-7-L1-hair-color-2"), Color: 3 },
                { Layer: M("Hair", "hair-7-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: M("Hair", "hair-8-L0-contour"), Color: null },
                { Layer: M("Hair", "hair-8-L1-hair-color-2"), Color: 3 },
                { Layer: M("Hair", "hair-8-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: M("Hair", "hair-9-L0-contour"), Color: null },
                { Layer: M("Hair", "hair-9-L1-hair-color-2"), Color: 3 },
                { Layer: M("Hair", "hair-9-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: M("Hair", "hair-10-L0-contour"), Color: null },
                { Layer: M("Hair", "hair-10-L1-hair-color-2"), Color: 3 },
                { Layer: M("Hair", "hair-10-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: M("Hair", "hair-sport-L0-contour"), Color: null },
                { Layer: M("Hair", "hair-sport-L1-hair-color-2"), Color: 3 },
                { Layer: M("Hair", "hair-sport-L2-hair-color-1"), Color: 4 },
                { Layer: M("Hair", "hair-sport-L3-contour"), Color: null },
                { Layer: M("Hair", "hair-sport-L4-outfit-color-1"), Color: 5 },
                { Layer: M("Hair", "hair-sport-L5-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: M("Hair", "hair-superhero-L0-contour"), Color: null },
                { Layer: M("Hair", "hair-superhero-L1-hair-color-2"), Color: 3 },
                { Layer: M("Hair", "hair-superhero-L2-hair-color-1"), Color: 4 },
            ],
        ],
        Nose: [
            [
                { Layer: M("Nose", "nose-2-L0-skin-color-2"), Color: 2 },
                { Layer: M("Nose", "nose-2-L1-contour"), Color: null },
            ],
            [
                { Layer: M("Nose", "nose-4-L0-skin-color-2"), Color: 2 },
                { Layer: M("Nose", "nose-4-L1-contour"), Color: null },
            ],
            [
                { Layer: M("Nose", "nose-6-L0-skin-color-2"), Color: 2 },
                { Layer: M("Nose", "nose-6-L1-contour"), Color: null },
            ],
            [
                { Layer: M("Nose", "nose-7-L0-skin-color-2"), Color: 2 },
                { Layer: M("Nose", "nose-7-L1-contour"), Color: null },
            ],
            [
                { Layer: M("Nose", "nose-8-L0-skin-color-2"), Color: 2 },
                { Layer: M("Nose", "nose-8-L1-contour"), Color: null },
            ],
            [
                { Layer: M("Nose", "nose-9-L0-skin-color-2"), Color: 2 },
                { Layer: M("Nose", "nose-9-L1-contour"), Color: null },
            ],
            [
                { Layer: M("Nose", "nose-10-L0-skin-color-2"), Color: 2 },
                { Layer: M("Nose", "nose-10-L1-contour"), Color: null },
            ],
            [
                { Layer: M("Nose", "nose-13-L0-skin-color-1"), Color: 1 },
                { Layer: M("Nose", "nose-13-L1-skin-color-2"), Color: 2 },
                { Layer: M("Nose", "nose-13-L2-contour"), Color: null },
            ],
            [
                { Layer: M("Nose", "nose-14-L0-skin-color-2"), Color: 2 },
                { Layer: M("Nose", "nose-14-L1-contour"), Color: null },
            ],
            [
                { Layer: M("Nose", "nose-17-L0-skin-color-1"), Color: 1 },
                { Layer: M("Nose", "nose-17-L1-skin-color-2"), Color: 2 },
                { Layer: M("Nose", "nose-17-L2-contour"), Color: null },
            ],
            [
                { Layer: M("Nose", "nose-easter-L0-skin-color-2"), Color: 2 },
                { Layer: M("Nose", "nose-easter-L1-contour"), Color: null },
                { Layer: M("Nose", "face-L3-easter-skin-color-3"), Color: 9 },
            ],
        ],
        Clothes: [
            [
                { Layer: M("Clothes", "body-1-L0-contour"), Color: null },
                { Layer: M("Clothes", "body-1-L1-skin-color-2"), Color: 2 },
                { Layer: M("Clothes", "body-1-L2-outfit-color-1"), Color: 5 },
                { Layer: M("Clothes", "body-1-L3-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: M("Clothes", "body-2-L0-contour"), Color: null },
                { Layer: M("Clothes", "body-1-L1-skin-color-2"), Color: 2 },
                { Layer: M("Clothes", "body-1-L2-outfit-color-1"), Color: 5 },
                { Layer: M("Clothes", "body-2-L1-outfit-color-1"), Color: 5 },
                { Layer: M("Clothes", "body-2-L2-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: M("Clothes", "body-3-L0-contour"), Color: null },
                { Layer: M("Clothes", "body-3-L1-skin-color-2"), Color: 2 },
                { Layer: M("Clothes", "body-3-L2-outfit-color-1"), Color: 5 },
                { Layer: M("Clothes", "body-3-L3-outfit-color-2"), Color: 6 },
                { Layer: M("Clothes", "body-3-L4-contour"), Color: null },
            ],
            [
                { Layer: M("Clothes", "body-4-L0-contour"), Color: null },
                { Layer: M("Clothes", "body-4-L1-skin-color-2"), Color: 2 },
                { Layer: M("Clothes", "body-4-L2-outfit-color-1"), Color: 5 },
                { Layer: M("Clothes", "body-4-L3-outfit-color-2"), Color: 6 },
                { Layer: M("Clothes", "body-4-L4-contour"), Color: null },
            ],
            [
                { Layer: M("Clothes", "body-5-L0-contour"), Color: null },
                { Layer: M("Clothes", "body-5-L1-skin-color-2"), Color: 2 },
                { Layer: M("Clothes", "body-5-L2-outfit-color-1"), Color: 5 },
                { Layer: M("Clothes", "body-5-L3-outfit-color-2"), Color: 6 },
                { Layer: M("Clothes", "body-5-L4-outfit-color-3"), Color: 7 },
                { Layer: M("Clothes", "body-5-L5-outfit-color-4"), Color: 8 },
                { Layer: M("Clothes", "body-5-L6-contour"), Color: null },
            ],
            [
                { Layer: M("Clothes", "body-6-L0-contour"), Color: null },
                { Layer: M("Clothes", "body-6-L1-skin-color-1"), Color: 1 },
                { Layer: M("Clothes", "body-6-L2-skin-color-2"), Color: 2 },
                { Layer: M("Clothes", "body-6-L3-outfit-color-1"), Color: 5 },
                { Layer: M("Clothes", "body-6-L4-outfit-color-2"), Color: 6 },
                { Layer: M("Clothes", "body-6-L5-contour"), Color: null },
            ],
            [
                { Layer: M("Clothes", "body-7-L0-contour"), Color: null },
                { Layer: M("Clothes", "body-7-L1-skin-color-2"), Color: 2 },
                { Layer: M("Clothes", "body-7-L2-outfit-color-1"), Color: 5 },
                { Layer: M("Clothes", "body-7-L3-outfit-color-2"), Color: 6 },
                { Layer: M("Clothes", "body-7-L4-outfit-color-3"), Color: 7 },
                { Layer: M("Clothes", "body-7-L5-outfit-color-4"), Color: 8 },
                { Layer: M("Clothes", "body-7-L6-contour"), Color: null },
            ],
            [
                { Layer: M("Clothes", "body-8-L0-contour"), Color: null },
                { Layer: M("Clothes", "body-8-L1-skin-color-2"), Color: 2 },
                { Layer: M("Clothes", "body-8-L2-outfit-color-1"), Color: 5 },
                { Layer: M("Clothes", "body-8-L3-outfit-color-2"), Color: 6 },
                { Layer: M("Clothes", "body-8-L4-outfit-color-3"), Color: 7 },
                { Layer: M("Clothes", "body-8-L5-outfit-color-4"), Color: 8 },
            ],
            [
                { Layer: M("Clothes", "body-sport-L0-contour"), Color: null },
                { Layer: M("Clothes", "body-sport-L1-skin-color-1"), Color: 1 },
                { Layer: M("Clothes", "body-sport-L2-skin-color-2"), Color: 2 },
                { Layer: M("Clothes", "body-sport-L3-shirt-contour"), Color: null },
                { Layer: M("Clothes", "body-sport-L4-outfit-color-1"), Color: 5 },
                { Layer: M("Clothes", "body-sport-L5-outfit-color-2"), Color: 6 },
                { Layer: M("Clothes", "body-sport-L6-white"), Color: 7 },
                { Layer: M("Clothes", "body-sport-L7-shadow"), Color: 8 },
            ],
            [
                { Layer: M("Clothes", "body-easter-L0-contour"), Color: null },
                { Layer: M("Clothes", "body-easter-L1-skin-color-2"), Color: 2 },
                { Layer: M("Clothes", "body-easter-L2-outfit-color-1"), Color: 5 },
                { Layer: M("Clothes", "body-easter-L3-outfit-color-2"), Color: 6 },
                { Layer: M("Clothes", "body-easter-L4-outfit-color-3"), Color: 7 },
                { Layer: M("Clothes", "body-easter-L5-outfit-color-4"), Color: 8 },
                { Layer: M("Clothes", "body-easter-L6-contour"), Color: null },
                { Layer: M("Clothes", "body-easter-L7-outfit-color-1"), Color: 5 },
                { Layer: M("Clothes", "body-easter-L8-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: M("Clothes", "body-superhero-L0-contour-new"), Color: null },
                { Layer: M("Clothes", "body-superhero-L1-skin-color-2-new"), Color: 2 },
                { Layer: M("Clothes", "body-superhero-L2-outfit-color-1"), Color: 5 },
                { Layer: M("Clothes", "body-superhero-L3-outfit-color-2"), Color: 6 },
                { Layer: M("Clothes", "body-superhero-L4-outfit-color-3"), Color: 7 },
                { Layer: M("Clothes", "body-superhero-L5-outfit-color-4"), Color: 8 },
                { Layer: M("Clothes", "body-superhero-L6-cape"), Color: null },
            ],
            [
                { Layer: M("Clothes", "body-1-L0-contour"), Color: null },
                { Layer: M("Clothes", "body-1-L1-skin-color-2"), Color: 2 },
                { Layer: M("Clothes", "space-suit-L0-contour"), Color: null },
                { Layer: M("Clothes", "space-suit-L1-outfit-color-3"), Color: 7 },
                { Layer: M("Clothes", "space-suit-L2-outfit-color-4"), Color: 8 },
                { Layer: M("Clothes", "space-suit-L3-outfit-color-1"), Color: 5 },
                { Layer: M("Clothes", "space-suit-L4-outfit-color-2"), Color: 6 },
                { Layer: M("Clothes", "space-suit-L5-white"), Color: null },
            ],
        ],
        Extras: [
            [{ Layer: M("Extras", "extras-5-beard-1-L0"), Color: null }],
            [{ Layer: M("Extras", "extras-1-moustache-L0"), Color: null }],
            [{ Layer: M("Extras", "extras-3-screws-L0"), Color: null }],
            [{ Layer: M("Extras", "extras-4-wound-L0-skin-color-2"), Color: 2 }],
            [{ Layer: M("Extras", "extras-6-beard-2-L0"), Color: null }],
            [{ Layer: M("Extras", "extras-7-earrings-L0"), Color: null }],
            [{ Layer: M("Extras", "extras-8-glasses-L0"), Color: null }],
            [{ Layer: M("Extras", "extras-9-wrinklesL0-skin-color-2"), Color: 2 }],
            [{ Layer: M("Extras", "extras-10-brain-L0"), Color: null }],
            [{ Layer: M("Extras", "face-L3-superhero-mask"), Color: null }],
            [
                { Layer: M("Hair", "space-helmet-L0-contour"), Color: null },
                { Layer: M("Hair", "space-helmet-L1-outfit-color-3"), Color: 7 },
                { Layer: M("Hair", "space-helmet-L2-outfit-color-4"), Color: 8 },
                { Layer: M("Hair", "space-helmet-L3-outfit-color-1"), Color: 5 },
                { Layer: M("Hair", "space-helmet-L4-outfit-color-2"), Color: 6 },
                { Layer: M("Hair", "space-helmet-L5-white"), Color: null },
            ],
        ],
    },
    Woman: {
        Ears: [
            [
                { Layer: W("Ears", "ears-L0-contour"), Color: null },
                { Layer: W("Ears", "ears-L1-skin-color-1"), Color: 1 },
                { Layer: W("Ears", "ears-L2-skin-color-2"), Color: 2 },
                { Layer: W("Ears", "ears-L3-contour"), Color: null },
            ],
        ],
        Body: [
            [
                { Layer: W("Body", "body-L0-contour"), Color: null },
                { Layer: W("Body", "body-L1-skin-color-1"), Color: 1 },
                { Layer: W("Body", "body-L2-skin-color-2"), Color: 2 },
            ],
        ],
        Face: [
            {
                Layer0: W("Face", "face-L0-contour"),
                Layer1: W("Face", "face-L1-skin-color-1"),
                Layer2: [
                    W("Face", "face-L2-hair-4-skin-color-2"),
                    W("Face", "face-L2-hair-7-skin-color-2"),
                    W("Face", "face-L2-hair-9-skin-color-2"),
                    W("Face", "face-L2-hair-10-skin-color-2"),
                    W("Face", "face-L2-hair-12-skin-color-2"),
                    W("Face", "face-L2-hair-13-skin-color-2"),
                    W("Face", "face-L2-hair-4-skin-color-2"),
                    W("Face", "face-L2-hair-15-skin-color-2"),
                    W("Face", "face-L2-hair-19-skin-color-2"),
                    W("Face", "face-L2-hair-21-skin-color-2"),
                    W("Face", "face-L2-hair-23-skin-color-2"),
                    W("Face", "face-L2-hair-sport-skin-color-2"),
                    W("Face", "face-L2-hair-superhero-skin-color-2"),
                ],
            },
        ],
        Mouth: [
            [{ Layer: W("Mouth", "mouth-32-L0"), Color: null }],
            [
                { Layer: W("Mouth", "mouth-2-L0-skin-color-2"), Color: 2 },
                { Layer: W("Mouth", "mouth-2-L1"), Color: null },
            ],
            [
                { Layer: W("Mouth", "mouth-4-L0-skin-color-2"), Color: 2 },
                { Layer: W("Mouth", "mouth-4-L1"), Color: null },
            ],
            [{ Layer: W("Mouth", "mouth-14-L0"), Color: null }],
            [
                { Layer: W("Mouth", "mouth-19-L0-skin-color-2"), Color: 2 },
                { Layer: W("Mouth", "mouth-19-L1"), Color: null },
            ],
            [{ Layer: W("Mouth", "mouth-23-L0"), Color: null }],
            [
                { Layer: W("Mouth", "mouth-31-L0-skin-color-2"), Color: 2 },
                { Layer: W("Mouth", "mouth-31-L1"), Color: null },
            ],
            [{ Layer: W("Mouth", "mouth-33-L0"), Color: null }],
            [{ Layer: W("Mouth", "mouth-36-L0"), Color: null }],
            [{ Layer: W("Mouth", "mouth-37-L0"), Color: null }],
        ],
        Eyes: [
            [{ Layer: W("Eyes", "eyes-18-L0"), Color: null }],
            [{ Layer: W("Eyes", "eyes-13-L0"), Color: null }],
            [{ Layer: W("Eyes", "eyes-17-L0"), Color: null }],
            [{ Layer: W("Eyes", "eyes-19-L0"), Color: null }],
            [{ Layer: W("Eyes", "eyes-20-L0"), Color: null }],
            [{ Layer: W("Eyes", "eyes-21-L0"), Color: null }],
            [{ Layer: W("Eyes", "eyes-22-L0"), Color: null }],
            [{ Layer: W("Eyes", "eyes-23-L0"), Color: null }],
            [{ Layer: W("Eyes", "eyes-24-L0"), Color: null }],
            [{ Layer: W("Eyes", "eyes-25-L0"), Color: null }],
        ],
        Brows: [
            [{ Layer: W("Brows", "brows-1-L0"), Color: null }],
            [{ Layer: W("Brows", "brows-10-L0"), Color: null }],
            [{ Layer: W("Brows", "brows-14-L0"), Color: null }],
            [{ Layer: W("Brows", "brows-17-L0"), Color: null }],
            [{ Layer: W("Brows", "brows-18-L0"), Color: null }],
            [{ Layer: W("Brows", "brows-23-L0"), Color: null }],
            [{ Layer: W("Brows", "brows-25-L0"), Color: null }],
            [{ Layer: W("Brows", "brows-26-L0"), Color: null }],
            [{ Layer: W("Brows", "brows-27-L0"), Color: null }],
            [{ Layer: W("Brows", "brows-28-L0"), Color: null }],
        ],
        Hair: [
            [
                { Layer: W("Hair", "hair-4-L0-contour"), Color: null },
                { Layer: W("Hair", "hair-4-L1-hair-color-2"), Color: 3 },
                { Layer: W("Hair", "hair-4-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: W("Hair", "hair-7-L0-contour"), Color: null },
                { Layer: W("Hair", "hair-7-L1-hair-color-2"), Color: 3 },
                { Layer: W("Hair", "hair-7-L2-hair-color-1"), Color: 4 },
                { Layer: W("Hair", "hair-7-L3-outfit-color-1"), Color: 5 },
            ],
            [
                { Layer: W("Hair", "hair-9-L0-contour"), Color: null },
                { Layer: W("Hair", "hair-9-L1-hair-color-2"), Color: 3 },
                { Layer: W("Hair", "hair-9-L2-hair-color-1"), Color: 4 },
                { Layer: W("Hair", "hair-9-L3-outfit-color-1"), Color: 5 },
                { Layer: W("Hair", "hair-9-L4-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: W("Hair", "hair-10-L0-contour"), Color: null },
                { Layer: W("Hair", "hair-10-L1-hair-color-2"), Color: 3 },
                { Layer: W("Hair", "hair-10-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: W("Hair", "hair-12-L0-contour-1"), Color: null },
                { Layer: W("Hair", "hair-12-L1-hair-color-2"), Color: 3 },
                { Layer: W("Hair", "hair-12-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: W("Hair", "hair-13-L0-contour"), Color: null },
                { Layer: W("Hair", "hair-13-L1-hair-color-2"), Color: 3 },
                { Layer: W("Hair", "hair-13-L2-hair-color-1"), Color: 4 },
            ],
            [{ Layer: W("Hair", "hair-bold"), Color: null }],
            [
                { Layer: W("Hair", "hair-15-L0-contour-1"), Color: null },
                { Layer: W("Hair", "hair-15-L1-hair-color-2"), Color: 3 },
                { Layer: W("Hair", "hair-15-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: W("Hair", "hair-19-L0-contour"), Color: null },
                { Layer: W("Hair", "hair-19-L1-hair-color-2"), Color: 3 },
                { Layer: W("Hair", "hair-19-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: W("Hair", "hair-21-L0-contour"), Color: null },
                { Layer: W("Hair", "hair-21-L1-hair-color-2"), Color: 3 },
                { Layer: W("Hair", "hair-21-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: W("Hair", "hair-23-L0-contour"), Color: null },
                { Layer: W("Hair", "hair-23-L1-hair-color-2"), Color: 3 },
                { Layer: W("Hair", "hair-23-L2-hair-color-1"), Color: 4 },
            ],
            [
                { Layer: W("Hair", "hair-sport-L0-contour"), Color: null },
                { Layer: W("Hair", "hair-sport-L1-hair-color-2"), Color: 3 },
                { Layer: W("Hair", "hair-sport-L2-hair-color-1"), Color: 4 },
                { Layer: W("Hair", "hair-sport-L3-outfit-color-1"), Color: 5 },
                { Layer: W("Hair", "hair-sport-L4-outfit-color-2"), Color: 6 },
                { Layer: W("Hair", "hair-sport-L5-white"), Color: 7 },
            ],
            [
                { Layer: W("Hair", "hair-superhero-L0-contour"), Color: null },
                { Layer: W("Hair", "hair-superhero-L1-hair-color-2"), Color: 3 },
                { Layer: W("Hair", "hair-superhero-L2-hair-color-1"), Color: 4 },
            ],
        ],
        Nose: [
            [
                { Layer: W("Nose", "nose-2-L0-skin-color-2"), Color: 2 },
                { Layer: W("Nose", "nose-2-L1-contour"), Color: null },
            ],
            [
                { Layer: W("Nose", "nose-3-L0-skin-color-2"), Color: 2 },
                { Layer: W("Nose", "nose-3-L1-contour"), Color: null },
            ],
            [
                { Layer: W("Nose", "nose-7-L0-skin-color-2"), Color: 2 },
                { Layer: W("Nose", "nose-7-L1-contour"), Color: null },
            ],
            [
                { Layer: W("Nose", "nose-8-L0-skin-color-2"), Color: 2 },
                { Layer: W("Nose", "nose-8-L1-contour"), Color: null },
            ],
            [
                { Layer: W("Nose", "nose-14-L0-skin-color-2"), Color: 2 },
                { Layer: W("Nose", "nose-17-L1-contour"), Color: null },
            ],
            [
                { Layer: W("Nose", "nose-18-L0-skin-color-2"), Color: 2 },
                { Layer: W("Nose", "nose-18-L1-contour"), Color: null },
            ],
            [
                { Layer: W("Nose", "nose-19-L0-skin-color-2"), Color: 2 },
                { Layer: W("Nose", "nose-19-L1-contour"), Color: null },
            ],
            [
                { Layer: W("Nose", "nose-20-L0-skin-color-2"), Color: 2 },
                { Layer: W("Nose", "nose-20-L1-contour"), Color: null },
            ],
            [
                { Layer: W("Nose", "nose-21-L0-skin-color-2"), Color: 2 },
                { Layer: W("Nose", "nose-21-L1-contour"), Color: null },
            ],
            [
                { Layer: W("Nose", "nose-22-L0-skin-color-2"), Color: 2 },
                { Layer: W("Nose", "nose-22-L1-contour"), Color: null },
            ],
            [
                { Layer: W("Nose", "nose-easter-L0-skin-color-2"), Color: 2 },
                { Layer: W("Nose", "nose-easter-L1-contour"), Color: null },
                { Layer: W("Nose", "face-L3-easter-skin-color-3"), Color: 9 },
            ],
        ],
        Clothes: [
            [
                { Layer: W("Clothes", "clothes-1-L0-contour"), Color: null },
                { Layer: W("Clothes", "clothes-1-L1-outfit-color-1"), Color: 5 },
                { Layer: W("Clothes", "clothes-1-L2-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: W("Clothes", "clothes-2-L0-contour"), Color: null },
                { Layer: W("Clothes", "clothes-2-L1-outfit-color-1"), Color: 5 },
                { Layer: W("Clothes", "clothes-2-L2-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: W("Clothes", "clothes-3-L0-contour-1"), Color: null },
                { Layer: W("Clothes", "clothes-3-L1-outfit-color-1"), Color: 5 },
                { Layer: W("Clothes", "clothes-3-L2-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: W("Clothes", "clothes-4-L0-contour"), Color: null },
                { Layer: W("Clothes", "clothes-4-L1-outfit-color-1"), Color: 5 },
                { Layer: W("Clothes", "clothes-4-L2-outfit-color-3"), Color: 7 },
                { Layer: W("Clothes", "clothes-4-L3-outfit-color-4"), Color: 8 },
            ],
            [
                { Layer: W("Clothes", "clothes-5-L0-outfit-color-1"), Color: 5 },
                { Layer: W("Clothes", "clothes-5-L1-outfit-color-2"), Color: 6 },
                { Layer: W("Clothes", "clothes-5-L2-contour"), Color: null },
                { Layer: W("Clothes", "clothes-5-L3-outfit-color-3"), Color: 7 },
                { Layer: W("Clothes", "clothes-5-L4-outfit-color-4"), Color: 8 },
            ],
            [
                { Layer: W("Clothes", "clothes-6-L0-outfit-color-1"), Color: 5 },
                { Layer: W("Clothes", "clothes-6-L1-outfit-color-2"), Color: 6 },
                { Layer: W("Clothes", "clothes-6-L2-contour"), Color: null },
                { Layer: W("Clothes", "clothes-6-L3-outfit-color-3"), Color: 7 },
                { Layer: W("Clothes", "clothes-6-L4-outfit-color-4"), Color: 8 },
            ],
            [
                { Layer: W("Clothes", "clothes-7-L0-outfit-color-1"), Color: 5 },
                { Layer: W("Clothes", "clothes-7-L1-outfit-color-2"), Color: 6 },
                { Layer: W("Clothes", "clothes-7-L2-contour"), Color: null },
                { Layer: W("Clothes", "clothes-7-L3-outfit-color-1"), Color: 5 },
                { Layer: W("Clothes", "clothes-7-L4-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: W("Clothes", "clothes-8-L0-outfit-color-2"), Color: 6 },
                { Layer: W("Clothes", "clothes-8-L1-contour"), Color: null },
                { Layer: W("Clothes", "clothes-8-L2-outfit-color-1"), Color: 5 },
                { Layer: W("Clothes", "clothes-8-L3-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: W("Clothes", "clothes-sport-L0-contour"), Color: null },
                { Layer: W("Clothes", "clothes-sport-L1-white"), Color: 7 },
                { Layer: W("Clothes", "clothes-sport-L2-shadow"), Color: 8 },
                { Layer: W("Clothes", "clothes-sport-L3-outfit-color-1"), Color: 5 },
                { Layer: W("Clothes", "clothes-sport-L4-outfit-color-2"), Color: 6 },
            ],
            [
                { Layer: W("Clothes", "clothes-easter-L0"), Color: null },
                { Layer: W("Clothes", "clothes-easter-L0-contour"), Color: null },
                { Layer: W("Clothes", "clothes-easter-L1-outfit-color-1"), Color: 5 },
                { Layer: W("Clothes", "clothes-easter-L2-outfit-color-2"), Color: 6 },
                { Layer: W("Clothes", "clothes-easter-L3-eggs"), Color: 7 },
            ],
            [
                { Layer: W("Clothes", "clothes-superhero-L0-outfit-color-1"), Color: 5 },
                { Layer: W("Clothes", "clothes-superhero-L1-outfit-color-2"), Color: 6 },
                { Layer: W("Clothes", "clothes-superhero-L2-contour"), Color: null },
                { Layer: W("Clothes", "clothes-superhero-L3-outfit-color-3"), Color: 7 },
                { Layer: W("Clothes", "clothes-superhero-L4-outfit-color-4"), Color: 8 },
                { Layer: W("Clothes", "clothes-superhero-L5-cape"), Color: null },
            ],
            [
                { Layer: W("Clothes", "space-suit-L0-contour"), Color: null },
                { Layer: W("Clothes", "space-suit-L1-outfit-color-3"), Color: 7 },
                { Layer: W("Clothes", "space-suit-L2-outfit-color-4"), Color: 8 },
                { Layer: W("Clothes", "space-suit-L3-outfit-color-1"), Color: 5 },
                { Layer: W("Clothes", "space-suit-L4-outfit-color-2"), Color: 6 },
                { Layer: W("Clothes", "space-suit-L5-white"), Color: null },
            ],
        ],
        Extras: [
            [{ Layer: W("Extras", "extras-1-freckless-L0-skin-color-2"), Color: 2 }],
            [{ Layer: W("Extras", "extras-2-cheeks-L0-skin-color-3"), Color: 9 }],
            [{ Layer: W("Extras", "extras-3-wound-L0-skin-color-2"), Color: 2 }],
            [{ Layer: W("Extras", "extras-4-earrings-1-L0"), Color: null }],
            [
                { Layer: W("Extras", "extras-5-earrings-2-L0-contour"), Color: null },
                { Layer: W("Extras", "extras-5-earrings-2-L1-outfit-color-2"), Color: 6 },
                { Layer: W("Extras", "extras-5-earrings-2-L2-outfit-color-1"), Color: 5 },
            ],
            [{ Layer: W("Extras", "extras-6-earrings-3-L0"), Color: null }],
            [
                { Layer: W("Extras", "extras-7-crown-L0"), Color: null },
                { Layer: W("Extras", "extras-7-crown-L1"), Color: null },
                { Layer: W("Extras", "extras-7-crown-L2"), Color: null },
                { Layer: W("Extras", "extras-7-crown-L3-outfit-color-1"), Color: 5 },
                { Layer: W("Extras", "extras-7-crown-L4-outfit-color-2"), Color: 6 },
                { Layer: W("Extras", "extras-7-crown-L5"), Color: null },
            ],
            [{ Layer: W("Extras", "extras-8-glasses-1-L0"), Color: null }],
            [{ Layer: W("Extras", "extras-9-glasses-2-L0"), Color: null }],
            [
                { Layer: W("Extras", "extras-easter-L0-contour"), Color: null },
                { Layer: W("Extras", "extras-easter-L1-outfit-color-1"), Color: 5 },
                { Layer: W("Extras", "extras-easter-L2-outfit-color-2"), Color: 6 },
                { Layer: W("Extras", "extras-easter-L2-skin-color-1"), Color: 1 },
                { Layer: W("Extras", "extras-easter-L3-skin-color-2"), Color: 2 },
            ],
            [{ Layer: W("Extras", "face-L3-superhero-mask"), Color: null }],
            [
                { Layer: W("Hair", "space-helmet-L0-contour"), Color: null },
                { Layer: W("Hair", "space-helmet-L1-outfit-color-3"), Color: 7 },
                { Layer: W("Hair", "space-helmet-L2-outfit-color-4"), Color: 8 },
                { Layer: W("Hair", "space-helmet-L3-outfit-color-1"), Color: 6 },
                { Layer: W("Hair", "space-helmet-L4-outfit-color-2"), Color: 5 },
                { Layer: W("Hair", "space-helmet-L5-white"), Color: null },
            ],
        ],
    },
};

// Layer names in display order for the UI
export const LayerNames = ["Ears", "Body", "Face", "Mouth", "Eyes", "Brows", "Hair", "Nose", "Clothes", "Extras"];

// Draw order for canvas compositing (back to front)
export const DrawOrder = ["Ears", "Body", "Clothes", "Face", "Mouth", "Nose", "Eyes", "Brows", "Hair", "Extras"];

// Character type display names
export const CharacterTypes = ["Girl", "Boy", "Man", "Woman"];
